import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidTaxpayerDateOfBirthError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.company.validation.taxpayer-date-of-birth.not-empty');
    }
}
